import styled from "styled-components";

export const MessageDropdownWrapper = styled.div`
  width: 320px;
  overflow: hidden;
  background: #343538;
`;
export const MessageLink = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  background: #2c2d31;
  border-bottom: 1px solid #515356;
  padding: 0 12px;
  a {
    color: var(--main-color);
  }
  a:hover {
    color: var(--main-color-btn-hover);
  }
`;

export const MoreText = styled.div`
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  border-top: 1px solid #515356;
  span {
    cursor: pointer;
  }
  a {
    color: var(--main-color);
  }
  a:hover {
    color: var(--main-color-btn-hover);
  }
  svg {
    vertical-align: middle;
    margin-left: 2px;
  }
`;
export const MesageListWrapper = styled.div``;
export const MessageItem = styled.div<{ isRead: boolean }>`
  font-size: 14px;
  color: ${(p) => (p.isRead ? p.theme["color-text-1"] : "#E0EDEF")};
  padding: 8px 12px;
  line-height: 18px;
  .create-time {
    color: ${(p) => p.theme["color-text-1"]};
    font-size: 12px;
    margin-top: 2px;
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 260px;
`;
